import { Action } from '@ngrx/store';

export interface AppError {
    title: string;
    subTitle: string;

    actionTitle?: string;
    actionHtmlId?: string;
    actionHtmlClass?: string;

    action?: Action;
}

/* TODO: convert to interface and remove resource text */
export class AppApiError implements AppError {
    title: string;
    action: Action;
    subTitle = 'APP.API.ERROR.SUBTITLE';
    actionTitle = 'APP.API.ERROR.RELOAD';
    actionHtmlClass = 'btn-icon btn-icon-left far fa-repeat';

    constructor(title: string, action: Action) {
        this.title = title;
        this.action = action;
    }
}
